import { Box, Text } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import DayPicker from 'modules/core/components/DayPicker'
import TextField from 'modules/core/components/TextField'
import TimePicker from 'modules/core/components/TimePicker'
import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { PostFormValues } from 'modules/posts/components/ManagePost/types'

interface Props {
  isEvent: boolean
}
const Event = ({ isEvent }: Props) => {
  const form = useFormContext<PostFormValues>()

  const setEventDay = (date: string) => {
    const localeData = moment.localeData()
    const format = localeData.longDateFormat('L')
    const newDate = moment(date, format)
    const existingDate = moment(form.values.startsAt)

    existingDate
      .set('date', newDate.date())
      .set('month', newDate.month())
      .set('year', newDate.year())

    form.setValues({ ...form.values, startsAt: existingDate.toISOString() })
  }
  const setEventTime = (time: string) => {
    const newTime = moment(time, 'HH:mm')
    const existingTime = moment(form.values.startsAt)
    existingTime.set('hour', newTime.hour()).set('minutes', newTime.minutes())

    form.setValues({ ...form.values, startsAt: existingTime.toISOString() })
  }
  const date = moment(form.values.startsAt).format('L')
  const time = moment(form.values.startsAt).format('HH:mm')

  return (
    <Box>
      <Box width="s600" flexDirection="row" gap="s16">
        <Box gap={'s6'} style={{ width: '25%' }}>
          <Text.Normal htmlTag="p" color="grey1000" size="200">
            {i18n.t('posts.communities.event_start_date')}
          </Text.Normal>
          <DayPicker
            minDate={moment().startOf('day')}
            value={date}
            onChange={(value: string) => setEventDay(value)}
            mandatory={isEvent}
          />
        </Box>
        <Box gap={'s6'} style={{ width: '25%' }}>
          <Text.Normal htmlTag="p" color="grey1000" size="200">
            {i18n.t('posts.communities.event_start_time')}
          </Text.Normal>
          <TimePicker
            onChange={(value: string) => setEventTime(value)}
            value={time}
            attachmentPosition="bottom right"
            mandatory={isEvent}
          />
        </Box>
        <Box gap={'s6'} style={{ width: '50%' }}>
          <Text.Normal htmlTag="p" color="grey1000" size="200">
            {i18n.t('posts.communities.event_location')}
          </Text.Normal>
          <TextField
            value={form.values.location}
            placeholder={i18n.t('posts.communities.event_location_placeholder')}
            onChange={(value: string) => {
              form.setValues({ ...form.values, location: value })
            }}
          />
        </Box>
      </Box>
      <Text size="200" color="radicalRed1000" capitalize>
        {form.errors.startsAt}
      </Text>
    </Box>
  )
}
export default observer(Event)
